<script>
import { GameLauncher } from "@/mixins/game-launcher";
import PrivateRoom from "@/views/app/dashboard/battleground/components/PrivateRoom.vue";

export default {
  name: "private-rooms",
  components: {PrivateRoom},

  mixins: [GameLauncher],

  data() {
    return {

    };
  },

};
</script>

<template>
  <div class="private-rooms-container px-3 pb-5">
    <v-img src="/images/icons/private-rooms.svg" class="mx-auto mt-5" max-width="50px"/>
    <div class="w-full text-center mt-2">
      <span class="text-h6 text-sm-h5 font-weight-800">Private Rooms</span>
    </div>
    <private-room/>
  </div>
</template>

<style scoped lang="scss">
.private-rooms-container {
  max-width: 1300px;
  margin: 0 auto;
}
</style>
